const mcNurgleData = {
  currentPoll: {
    // id: "S49-mcNurgle",
    id: null,
  },
  previousPoll: {
    // id: "S49-mcNurgle",
    id: null,
  },
};

export default mcNurgleData;
